export class District {
    id: number;
    name: string;
}
